import { render, staticRenderFns } from "./RemnantBasic.vue?vue&type=template&id=ad1702ea"
import script from "./RemnantBasic.vue?vue&type=script&lang=js"
export * from "./RemnantBasic.vue?vue&type=script&lang=js"
import style0 from "./RemnantBasic.vue?vue&type=style&index=0&id=ad1702ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports